'use es6';

import { createSelector } from 'reselect';
import { getEntry, getNotSetValue } from 'conversations-async-data/indexed-async-data/operators/getters';
import { getCurrentThreadId } from 'conversations-thread-data/thread-details/public/selectors';
import { getIndexedAsyncThreadDetails } from './getIndexedAsyncThreadDetails';
export const getAsyncFocusedThreadDetails = createSelector([getCurrentThreadId, getIndexedAsyncThreadDetails], (threadId, indexedAsyncThreadDetails) => threadId ? getEntry(threadId, indexedAsyncThreadDetails) : getNotSetValue(indexedAsyncThreadDetails));